module.exports = __webpack_public_path__ + "static/media/piriflu.25653a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/paratrioza/curativa/piriflu.png
// module id = 2004
// module chunks = 3